import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
//import { getToken } from "../auth/auth";
import "react-toastify/dist/ReactToastify.css";
//import "../styles/dashboard.css";
import Key from "../../clientVariables.json";
// import Sidebar from "../components/sidebar/Sidebar";
// import Navbar from "../components/navbar/Navbar";
// import TemplateOption from "../components/templateOption/TemplateOption";
// import key from "../clientVariables.json";
import LinearProgress from "@mui/material/LinearProgress";
import {
  TextField,
  Select,
  MenuItem,
  Button,
  Box,
  Typography,
  Alert,
  Toolbar,
  IconButton,
  TableContainer,
  Paper,
  Table, List,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ListItem,
  ListItemText,
  Grid,
  Divider,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ListItemAvatar,
  InputBase,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Stack, Avatar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../redux/selector";
import { resetCandidatesAction, selectedJobAction } from "../redux/action";
import moment from "moment";
import { userSelector } from "../user-redux/selector";
import ActiveCandidates from "../MyCandidates/CandidatesView/ActiveCandidates";
import { use } from "react";
import { useGoogleLogin, googleLogout } from "@react-oauth/google";
import { useMsal } from "@azure/msal-react";
import { Client } from "@microsoft/microsoft-graph-client";
import CircularProgress from "@mui/material/CircularProgress";
import { BiLogoGmail } from 'react-icons/bi';
import { PiMicrosoftOutlookLogoFill } from "react-icons/pi";
import Menu from "@mui/material/Menu";
import ListItemIcon from "@mui/material/ListItemIcon";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { loginRequest } from "../../helpers/msalConfig";
import LogoutIcon from "@mui/icons-material/Logout";

function Mailer({ setMailopen }) {
  const { selectedJob, activeCandidates, activeCandLoading, setActiveCandidates, vmail_token } = useSelector(appSelector);
  const { user } = useSelector(userSelector);
  const dispatch = useDispatch();
  const [groups, setGroups] = useState([]);
  const [fromMail, setFromMail] = useState("");
  const [group, setGroup] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState(" ");
  const [template, setTemplate] = useState("none");
  const [fromMailError, setFromMailError] = useState(false);
  const [groupError, setGroupError] = useState(false);
  const [subjectError, setSubjectError] = useState(false);
  const [fromMailHelperText, setFromMailHelperText] = useState("");
  const [groupHelperText, setGroupHelperText] = useState("");
  const [subjectHelperText, setSubjectHelperText] = useState("");
  const [CandidateData, setCandidateData] = useState(null);
  const [primaryResumes, setPrimaryResumes] = useState([]);
  const [outlookToken, setOutlookToken] = useState(null);
  const [gmailToken, setGmailToken] = useState(null);
  const [isGmailAuthenticated, setIsGmailAuthenticated] = useState(false);
  const [accessToken, setAccessToken] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [emailUserName, setEmailUserName] = useState(null)
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [attachment, setAttachment] = useState(null);
  const [attachmentName, setAttachmentName] = useState("");
  const [additionalText, setAdditionalText] = useState("");
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [profileDetails, setProfileDetails] = useState([]);

  const [editingCell, setEditingCell] = useState({ row: null, field: null });

  const [editOpen, setEditOpen] = useState(false);
  const [editName, setEditName] = useState("");
  const [editEmails, setEditEmails] = useState([]);
  const [editGroupId, setEditGroupId] = useState("");
  const [emailEditingIndex, setEmailEditingIndex] = useState(null);
  const [emailEditingValue, setEmailEditingValue] = useState("");
  const [newEmailEntry, setNewEmailEntry] = useState("");
  const [editSearchTerm, setEditSearchTerm] = useState("");
  const [sentCount, setSentCount] = useState(0);
  const [failedCount, setFailedCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [isOutlookAuthenticated, setIsOutlookAuthenticated] = useState(false);
  const NEED_THROTTLING_COMPANIES = [45721, 483370];
  const THROTTLE_GROUP_SIZE = 20;
  const isThrottledCompany =
    NEED_THROTTLING_COMPANIES.includes(Number(user.companyid));

  // useEffect(() => {
  //   console.log("activeCandidates", activeCandidates);
  // }, [activeCandidates]);

  const { instance, accounts } = useMsal()  // Disabled automatic account detection to prevent auto-linking sessions
  const syncOutlookAccount = () => {
    const allAccounts = instance.getAllAccounts();
    if (allAccounts.length > 0 && !isOutlookAuthenticated) {
      console.log("Active Outlook sessions found:", allAccounts.length);
    }
  };

  // Outlook authentication
  const acquireOutlookToken = async () => {
    setIsAuthenticating(true);
    try {
      await instance.loginPopup({
        ...loginRequest,
        prompt: "select_account"
      });
      let account = instance.getActiveAccount();
      if (!account) {
        const allAccounts = instance.getAllAccounts();
        if (allAccounts.length > 0) {
          account = allAccounts[0];
          instance.setActiveAccount(account);
        }
      }
      if (!account) throw new Error("No account available");
      const tokenResponse = await instance.acquireTokenSilent({
        ...loginRequest,
        account
      });
      setOutlookToken(tokenResponse.accessToken);
      setUserEmail(account.username);
      setEmailUserName(account.name)
      setIsOutlookAuthenticated(true);
      return tokenResponse.accessToken;
    } finally {
      setIsAuthenticating(false);
    }
  };

  const handleLogoutGoogle = () => {
    googleLogout();
    setGmailToken(null);
    setIsGmailAuthenticated(false);
    setUserEmail(null);
    toast.success("Gmail unlinked successfully");
  };

  const handleLogoutOutlook = async () => {
    try {
      await instance.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/",
      });
      setOutlookToken(null);
      setIsOutlookAuthenticated(false);
      setUserEmail(null);
      toast.success("Outlook unlinked successfully");
    } catch (e) {
      // If popup is blocked or closed, still clear local state
      setOutlookToken(null);
      setIsOutlookAuthenticated(false);
      setUserEmail(null);
      toast.success("Outlook unlinked successfully");
    }
  };

  const GMAIL_CLIENT_ID = "YOUR_GMAIL_CLIENT_ID"; // Replace with your client ID
  const SCOPES = "https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/gmail.readonly";

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setAccessToken(tokenResponse.access_token);
      setGmailToken(tokenResponse.access_token);
      setIsGmailAuthenticated(true);
      // Optionally fetch user email
      const userInfo = await axios.get(
        "https://www.googleapis.com/oauth2/v1/userinfo",
        {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`,
          },
        }
      );
      setUserEmail(userInfo.data?.email);
      setEmailUserName(user?.full_name)
      toast.success("Authentication successful");
    },
    onError: (error) => {
      toast.error("Gmail login failed");
    },
    scope: SCOPES,
    prompt: "select_account",
  });

  // Handle Input Change
  const handleChange = (e, rowIndex, field) => {
    // Note: Manual edits to the hotlist preview are currently read-only in this optimized view.
    // If editing is required, we would need to maintain a separate local buffer for activeCandidates.
  };

  // Set Cell in Edit Mode
  const handleEdit = (rowIndex, field) => {
    setEditingCell({ row: rowIndex, field });
  };

  // Save Data on Blur (or Enter)
  const handleBlur = () => {
    setEditingCell({ row: null, field: null });
  };

  useEffect(() => {
    const token = localStorage.getItem("MailFlow");
    const config = {
      headers: {
        Authorization: token,
      },
    };
    //console.log("MAILER: Fetching groups from", Key.domain_vmail);
    axios
      .get(`${Key.domain_vmail}/api/v1/user/viewgroups`, config)
      .then((res) => {
        setGroups(res.data.groups);
      })
      .catch((err) => {
        console.error("MAILER VIEWGROUPS ERROR:", err);
        if (err.response?.status === 401) {
          toast.error("Token expired, please login again.");
        }
      });
  }, []);

  const stringToColor = (string) => {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += ("00" + value.toString(16)).substr(-2);
    }
    return color;
  };

  const handleEditGroupClick = () => {
    if (!group) {
      toast.info("Please select a group to edit");
      return;
    }
    const selectedGroupData = groups.find((g) => g._id === group);
    if (selectedGroupData) {
      setEditGroupId(selectedGroupData._id);
      setEditName(selectedGroupData.name);
      setEditEmails(selectedGroupData.emails || []);
      setEditSearchTerm("");
      setEmailEditingIndex(null);
      setEmailEditingValue("");
      setNewEmailEntry("");
      setEditOpen(true);
    }
  };

  const handleUpdateSubmit = () => {
    const token = localStorage.getItem("MailFlow");
    if (!token) {
      toast.error("Session expired, Please login again.");
      return;
    }

    const config = {
      headers: {
        Authorization: token,
      },
    };

    setIsSubmitting(true);
    axios
      .post(
        `${Key.domain_vmail}/api/v1/user/updategroup/${editGroupId}`,
        {
          name: editName,
          emails: editEmails,
        },
        config
      )
      .then((res) => {
        setIsSubmitting(false);
        setEditOpen(false);
        toast.success("Successfully updated group");
        // Update local groups state
        const updatedGroups = groups.map((g) =>
          g._id === editGroupId ? { ...g, name: editName, emails: editEmails } : g
        );
        setGroups(updatedGroups);
        // Refresh group emails in Mailer if the currently selected group was updated
        if (group === editGroupId) {
          setGroupEmails(editEmails);
        }
      })
      .catch((err) => {
        console.error("Update API error:", err);
        setIsSubmitting(false);
        toast.error("Failed to update group");
      });
  };

  const handleRemoveEditEmail = (index) => {
    const updatedEmails = editEmails.filter((_, i) => i !== index);
    setEditEmails(updatedEmails);
  };

  const handleUpdateEditEmail = (index, newValue) => {
    const updatedEmails = editEmails.map((email, i) =>
      i === index ? newValue : email
    );
    setEditEmails(updatedEmails);
    setEmailEditingIndex(null);
  };

  const handleAddNewEditEmail = () => {
    if (newEmailEntry.trim() === "") return;
    if (!validateEmail(newEmailEntry)) {
      toast.error("Invalid email format");
      return;
    }
    setEditEmails([...editEmails, newEmailEntry.trim()]);
    setNewEmailEntry("");
  };

  // useEffect(() => {
  //   const loadDetails = async () => {
  //     if (activeCandidates?.length > 0) {
  //       const resumes = await getAllPrimaryResumes(activeCandidates);
  //       const details = await getAllProfileDetails(resumes);
  //       setPrimaryResumes(resumes);
  //       setProfileDetails(details);
  //     }
  //   };
  //   loadDetails();
  // }, [activeCandidates]);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };
  const handleFromMailChange = (e) => {
    const value = e.target.value;
  };
  const [groupEmails, setGroupEmails] = useState([]);

  const handleGroupChange = async (e) => {
    const value = e.target.value;
    setGroup(value);
    if (value === "") {
      setGroupError(true);
      setGroupHelperText("Select Contact from list");
    } else {
      setGroupError(false);
      setGroupHelperText("");
      const token = localStorage.getItem("MailFlow");
      try {
        const config = {
          headers: {
            Authorization: token,
          },
        };
        const response = await axios.post(
          `${Key.domain_vmail}/api/v1/user/getGroupEmails`,
          { groupId: value },
          config
        );
        // Assuming response.data.emails is an array of email strings
        setGroupEmails(response.data.emails || []);
      } catch (err) {
        console.error("Error fetching group emails:", err);
        toast.error("Failed to fetch group emails");
      }
    }
  };

  const handleSubjectChange = (e) => {
    const value = e.target.value;
    setSubject(value);
    if (value.trim() === "") {
      setSubjectError(true);
      setSubjectHelperText("Subject is required");
    } else {
      setSubjectError(false);
      setSubjectHelperText("");
    }
  };
  const handleFormSubmit = () => {
    let valid = true;

    // if (fromMail.trim() === "") {
    //   setFromMailError(true);
    //   setFromMailHelperText("From email is required.");
    //   valid = false;
    // }

    if (group === "") {
      setGroupError(true);
      setGroupHelperText("Select Contact from list");
      valid = false;
    } else {
      setGroupError(false);
      setGroupHelperText("");
    }

    if (subject.trim() === "") {
      setSubjectError(true);
      setSubjectHelperText("Subject is required");
      valid = false;
    } else {
      setSubjectError(false);
      setSubjectHelperText("");
    }

    if (valid) {
      handleSubmit();
    } else {
      toast.error("Please fill out all fields correctly", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const getAllPrimaryResumes = async (candidates) => {
    // Returns an array of primary resume objects (one per candidate)
    const requests = candidates.map(candidate =>
      axios.post(
        `${Key.domain}/candidate/get_primary_resume_details`,
        { candidate_id: candidate.candidate_id }
      )
        .then(res => res.data.data[0]) // get the first resume object
        .catch(() => null) // handle error for individual candidate
    );
    return Promise.all(requests);
  };

  const getAllProfileDetails = async (resumes) => {
    // resumes: array of primary resume objects (with .id)
    const requests = resumes.map(resume =>
      resume?.id
        ? axios.post(
          `${Key.domain}/candidate/get_js_profile_details`,
          { resume_id: resume.id }
        ).then(res => res.data?.data?.resumedetails || null)
        : Promise.resolve(null)
    );
    return Promise.all(requests);
  };



  const handleSubmit = async (provider, token) => {
    setIsSubmitting(true);
    try {
      // Validate recipients before proceeding
      if (!groupEmails || groupEmails.length === 0) {
        toast.error("Please select a group with recipient emails first.");
        setIsSubmitting(false);
        return;
      }

      setSentCount(0);
      setFailedCount(0);
      setTotalCount(0);

      // 1. Build table rows using candidate data directly from activeCandidates
      const ActiveCandidatesData =
        activeCandidates && activeCandidates.length > 0
          ? activeCandidates
            .map(
              (candidate, idx) =>
                candidate
                  ? `<tr>
                        <td style="font-size: 12px;">${candidate.candidate_name || "N/A"}</td>
                        <td style="padding: 0px 15px; font-size: 12px;">${candidate.role || "N/A"}</td>
                        <td style="font-size: 12px;">${candidate.work_experience || candidate.total_experience || candidate.experience || "N/A"}</td>
                        <td style="font-size: 12px;">${candidate.location || candidate.address || "N/A"}</td>
                      </tr>`
                  : `<tr><td colspan="4" style="font-size: 12px;">Candidate data missing #${idx + 1}</td></tr>`
            )
            .join("")
          : "";

      const template = `<html><head><style>#outlook a {padding: 0;}.ReadMsgBody {width: 100%;}.ExternalClass {width: 100%;}.ExternalClass * {line-height: 100%;}body {margin: 0;padding: 0;-webkit-text-size-adjust: 100%;-ms-text-size-adjust: 100%;}table td {border-collapse: collapse;mso-table-lspace: 0pt;mso-table-rspace: 0pt;}img {border: 0;height: auto;line-height: 100%;outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;}p {display: block;margin: 13px 0;}</style><style type="text/css">@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap');body,table,td,div,p {font-family: 'Poppins', sans-serif !important;}@media only screen and (min-width:480px) {.mj-column-per-100 {width: 100% !important;}}</style></head><body style="background-color:#f9f9f9;"><div style="background-color:#f9f9f9;"><div style="background:#f9f9f9;background-color:#f9f9f9;Margin:0px auto;max-width:700px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#f9f9f9;background-color:#f9f9f9;width:100%;"><tbody><tr><td style="border-bottom:#333957 solid 5px;direction:ltr;font-size:0px;padding:20px 0;text-align:center;vertical-align:top;"></td></tr></tbody></table></div><div style="background:#fff;background-color:#fff;Margin:0px auto;max-width:800px;"><table align="start" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fff;background-color:#fff;width:100%;"><tbody><tr><td style="border:#dddddd solid 1px;border-top:0px;direction:ltr;font-size:13px;padding:20px 0;text-align:center;vertical-align:top;"><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:bottom;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:bottom;" width="100%"><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:150px;"></td></tr></tbody></table></td></tr><tr><td align="start" style="font-size:16px;padding:10px 25px;padding-bottom:20px;word-break:break-word;"><p>Hi Team,</p><p>Hope you are doing great.</p><p>Please find the below attached hotlist and let us know if any of these talents align with your current needs.</p><table border="1" cellpadding="5" cellspacing="0" width="100%" style="border-collapse:collapse;"><thead style="background-color:#406882;color:#FFF;"><tr style="font-size: 12px;"><th>Name</th><th>Technology</th><th>Experience</th><th>Location</th></tr></thead><tbody>${ActiveCandidatesData}</tbody></table>
${additionalText ? `<div style="margin-top:20px;font-size:14px;">${additionalText.replace(/\n/g, "<br/>")}</div>` : ""}
</td></tr><tr><td align="left" style="font-size:14px;padding:10px 25px;word-break:break-word;"><div style="font-family:Helvetica Neue,Arial,sans-serif;font-size:14px;line-height:20px;text-align:left;color:#525252;">Regards<br>Name : <span>${emailUserName}</span><br>Email id : <span>${userEmail}</span><br>company Name : <span>${user?.companyname}</span></div></td></tr></table></div></td></tr></tbody></table></div><div style="Margin:0px auto;max-width:800px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:13px;padding:20px 0;text-align:center;vertical-align:top;"><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:bottom;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%"><tbody><tr><td style="vertical-align:bottom;padding:0;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%"><tr><td align="center" style="font-size:12px;padding:0;word-break:break-word;"><div style="font-family:'Helvetica Neue',Arial,sans-serif;font-size:12px;font-weight:300;line-height:1;text-align:center;color:#575757;">392 E Winchester St, Suite 201, Salt Lake City, Utah 84107 United States</div></td></tr><tr><td align="center" style="font-size:12px;padding:10px;word-break:break-word;"><div style="font-family:'Helvetica Neue',Arial,sans-serif;font-size:12px;font-weight:300;line-height:1;text-align:center;color:#575757;">Do not want to receive these mails? <a href="https://jobsnprofiles/unsubscribe/:email}" style="color:#406882">Click here</a> to unsubscribe.<br/><br/>Powered by <span style="color: orange;">Jobs'n'Profiles</span></div></td></tr></table></td></tr></tbody></table></div><table align="start" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:10px;padding:20px 0;text-align:center;vertical-align:top;"><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:bottom;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%"><tbody><tr><td style="vertical-align:bottom;padding:0;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%"><tr><td align="start" style="font-size:12px;padding:0;word-break:break-word;"><div style="font-family:'Poppins',Arial,sans-serif;font-size:12px;font-weight:300;line-height:1.2;text-align:center;color:#575757;"><p style="text-align: justify;"><b>Disclaimer</b>:<span>The content of this email is confidential and intended for the recipient specified in message only. It is strictly forbidden to share any part of this message with any third party, without a written consent of the sender. If you received this message by mistake, please reply to this message and follow with its deletion, so that we can ensure such a mistake does not occur in the future.</span></p></div></td></tr></table></td></tr></tbody></table></div></td></tr></tbody></table></div></div></body></html>`;

      // Prepare attachment if present
      let attachmentContent = "";
      if (attachment) {
        attachmentContent = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            const base64String = reader.result.split(",")[1];
            resolve(base64String);
          };
          reader.onerror = reject;
          reader.readAsDataURL(attachment);
        });
      }

      // Send one email per recipient
      if (provider === "gmail") {
        // Create a single email with all recipients in BCC
        let rawEmail;
        if (attachment) {
          const boundary = "boundary123";
          rawEmail =
            `From: ${userEmail}\r\n` +
            `To: ${userEmail}\r\n` +
            `Bcc: ${groupEmails.join(',')}\r\n` +
            `Subject: ${subject}\r\n` +
            `MIME-Version: 1.0\r\n` +
            `Content-Type: multipart/mixed; boundary="${boundary}"\r\n\r\n` +
            `--${boundary}\r\n` +
            `Content-Type: text/html; charset=UTF-8\r\n\r\n` +
            `${template}\r\n\r\n` +
            `--${boundary}\r\n` +
            `Content-Type: ${attachment.type}; name="${attachment.name}"\r\n` +
            `Content-Disposition: attachment; filename="${attachment.name}"\r\n` +
            `Content-Transfer-Encoding: base64\r\n\r\n` +
            `${attachmentContent}\r\n` +
            `--${boundary}--`;
          rawEmail = btoa(rawEmail)
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");
        } else {
          rawEmail = btoa(
            `From: ${userEmail}\r\n` +
            `To: ${userEmail}\r\n` + // Send to self
            `Bcc: ${groupEmails.join(',')}\r\n` + // All recipients in BCC
            `Subject: ${subject}\r\n` +
            `Content-Type: text/html; charset=UTF-8\r\n\r\n` +
            template
          )
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");
        }

        // Send single email to all recipients
        await axios.post(
          "https://gmail.googleapis.com/gmail/v1/users/me/messages/send",
          {
            raw: rawEmail,
            saveToSent: true
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

      } else if (provider === "outlook") {
        const sleep = (ms) =>
          new Promise((resolve) => setTimeout(resolve, ms));

        const outlookAttachments = attachment
          ? [
            {
              "@odata.type": "#microsoft.graph.fileAttachment",
              name: attachment.name,
              contentBytes: attachmentContent,
              contentType: attachment.type,
            },
          ]
          : [];

        const useSequentialSend =
          isThrottledCompany && groupEmails.length > THROTTLE_GROUP_SIZE;

        if (useSequentialSend) {
          setTotalCount(groupEmails.length);
          setSentCount(0);
          setFailedCount(0);

          for (let i = 0; i < groupEmails.length; i++) {
            const email = groupEmails[i];
            const message = {
              subject,
              body: {
                contentType: "HTML",
                content: template,
              },
              toRecipients: [
                {
                  emailAddress: {
                    address: email,
                  },
                },
              ],
              attachments: outlookAttachments,
            };

            try {
              await axios.post(
                "https://graph.microsoft.com/v1.0/me/sendMail",
                {
                  message,
                  saveToSentItems: true,
                },
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                  },
                }
              );

              setSentCount((prev) => prev + 1);
            } catch (err) {
              console.error("Failed:", email);
              setFailedCount((prev) => prev + 1);
            }

            if (i < groupEmails.length - 1) {
              await sleep(4000);
            }
          }
        } else {
          const message = {
            subject,
            body: {
              contentType: "HTML",
              content: template,
            },
            toRecipients: [{ emailAddress: { address: userEmail } }],
            bccRecipients: groupEmails.map((email) => ({
              emailAddress: { address: email },
            })),
            attachments: outlookAttachments,
          };

          await axios.post(
            "https://graph.microsoft.com/v1.0/me/sendMail",
            {
              message,
              saveToSentItems: true,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
        }
      }
      toast.success("Mail sent successfully!");
      setTimeout(() => {
        setMailopen(false);
      }, 1000);
    } catch (err) {
      console.error("Error sending Hot list email:", err);
      toast.error("Mail send failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  const pendingCount =
    totalCount - sentCount - failedCount;

  const handleTemplateOption = (temp) => {
    setTemplate(temp);
  };

  const handleInputChange = (setter, errorSetter, value) => {
    setter(value);
    if (value.trim() === "") {
      errorSetter(true);
    } else {
      errorSetter(false);
    }
  };

  // Dropdown send button
  return (
    <Box
      sx={{
        p: 0,
        bgcolor: "#f8fafc",
        height: "100%",
        maxHeight: "100%",
        minHeight: 0,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Toolbar
        sx={{
          bgcolor: "#f0f7ff",
          borderBottom: "2px solid #2563eb",
          px: 2,
          py: 2,
          minHeight: "80px !important",
          flexShrink: 0,
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            variant="h5"
            sx={{ fontWeight: 800, color: "#1e3a8a", letterSpacing: "-0.5px" }}
          >
            Email Campaign
          </Typography>
          <Typography variant="body2" sx={{ color: "#1e40af", fontWeight: 500 }}>
            Compose and broadcast your hotlist
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Button
            variant="contained"
            disableElevation
            onClick={(e) => setAnchorEl(e.currentTarget)}
            disabled={isSubmitting}
            startIcon={
              isSubmitting ? (
                <CircularProgress size={16} color="inherit" />
              ) : undefined
            }
            endIcon={!isSubmitting ? <KeyboardArrowDown /> : undefined}
            sx={{
              bgcolor: "#2563eb",
              color: "white",
              px: 3,
              py: 1,
              borderRadius: "10px",
              fontWeight: 700,
              textTransform: "none",
              fontSize: "0.95rem",
              boxShadow: "0 4px 6px -1px rgba(37, 99, 235, 0.2)",
              "&:hover": { bgcolor: "#1d4ed8" },
              "&.Mui-disabled": {
                bgcolor: "#2563eb",
                color: "white",
                opacity: 0.85,
              },
            }}
          >
            {isSubmitting ? "Sending…" : "Broadcast Ready"}
          </Button>
          {isSubmitting && totalCount > 0 && (
            <Box
              sx={{
                minWidth: 200,
                px: 1.5,
                py: 1,
                borderRadius: "10px",
                bgcolor: "rgba(37, 99, 235, 0.06)",
                border: "1px solid rgba(37, 99, 235, 0.12)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline",
                  mb: 0.75,
                  gap: 1,
                }}
              >
                <Typography
                  variant="caption"
                  sx={{ fontWeight: 600, color: "#1e40af", whiteSpace: "nowrap" }}
                >
                  Batch progress
                </Typography>
                <Typography variant="caption" sx={{ color: "#64748b" }}>
                  {sentCount}/{totalCount}
                  {failedCount > 0 && ` · ${failedCount} failed`}
                  {pendingCount > 0 && ` · ${pendingCount} left`}
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={Math.min(100, ((sentCount + failedCount) / totalCount) * 100)}
                sx={{
                  height: 5,
                  borderRadius: 4,
                  bgcolor: "rgba(37, 99, 235, 0.12)",
                  "& .MuiLinearProgress-bar": {
                    borderRadius: 4,
                    bgcolor: failedCount > 0 ? "#3b82f6" : "#2563eb",
                  },
                }}
              />
            </Box>
          )}
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              sx: {
                mt: 1.5,
                borderRadius: "14px",
                boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                border: "1px solid #e2e8f0",
                minWidth: "240px",
                p: 1,
              },
            }}
          >
            <MenuItem
              onClick={async () => {
                const wasAuthenticated = isOutlookAuthenticated;
                setAnchorEl(null);
                try {
                  let currentToken = outlookToken;
                  if (!wasAuthenticated || !currentToken) {
                    try {
                      currentToken = await acquireOutlookToken();
                      toast.success("Authentication successful");
                    } catch (e) {
                      toast.error("Outlook authentication failed");
                    }
                    return; // Return after authentication; don't try to send immediately
                  }
                  setIsSubmitting(true);
                  await handleSubmit("outlook", currentToken);
                } catch (error) {
                  console.error("Outlook send error:", error);
                } finally {
                  setIsSubmitting(false);
                }
              }}
              disabled={isAuthenticating || isSubmitting}
              sx={{ borderRadius: "10px", py: 1.5, mb: 0.5 }}
            >
              <ListItemIcon>
                <PiMicrosoftOutlookLogoFill fontSize="large" style={{ color: "#0078d4" }} />
              </ListItemIcon>
              <ListItemText
                primary={isOutlookAuthenticated ? "Send via Outlook" : "Link Outlook"}
                secondary={isOutlookAuthenticated ? userEmail : "Authenticate account"}
                primaryTypographyProps={{ fontWeight: 700, color: "#334155" }}
                secondaryTypographyProps={{ fontSize: "0.75rem" }}
              />
              {isOutlookAuthenticated && (
                <Tooltip title="Switch Account / Logout">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleLogoutOutlook();
                    }}
                    sx={{
                      ml: 1,
                      color: "#94a3b8",
                      "&:hover": { color: "#ef4444", bgcolor: "#fef2f2" }
                    }}
                  >
                    <LogoutIcon sx={{ fontSize: "18px" }} />
                  </IconButton>
                </Tooltip>
              )}
            </MenuItem>
            <MenuItem
              onClick={async () => {
                setAnchorEl(null);
                if (!isGmailAuthenticated) {
                  login({ prompt: "select_account" });
                } else {
                  await handleSubmit("gmail", gmailToken);
                }
              }}
              disabled={isSubmitting}
              sx={{ borderRadius: "10px", py: 1.5 }}
            >
              <ListItemIcon>
                <BiLogoGmail fontSize="large" style={{ color: "#ea4335" }} />
              </ListItemIcon>
              <ListItemText
                primary={isGmailAuthenticated ? "Send via Gmail" : "Link Gmail"}
                secondary={isGmailAuthenticated ? userEmail : "Authenticate account"}
                primaryTypographyProps={{ fontWeight: 700, color: "#334155" }}
                secondaryTypographyProps={{ fontSize: "0.75rem" }}
              />
              {isGmailAuthenticated && (
                <Tooltip title="Switch Account / Logout">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleLogoutGoogle();
                    }}
                    sx={{
                      ml: 1,
                      color: "#94a3b8",
                      "&:hover": { color: "#ef4444", bgcolor: "#fef2f2" }
                    }}
                  >
                    <LogoutIcon sx={{ fontSize: "18px" }} />
                  </IconButton>
                </Tooltip>
              )}
            </MenuItem>
          </Menu>

          <IconButton
            onClick={() => setMailopen(false)}
            sx={{
              bgcolor: "transparent",
              color: "#64748b",
              "&:hover": { bgcolor: "#f1f5f9" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Toolbar>

      <Box
        sx={{
          p: 3,
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Grid container spacing={3} sx={{ flex: 1, minHeight: 0, height: "100%" }}>
          <Grid item xs={12} md={5} sx={{ height: { md: "100%" }, display: "flex", minHeight: 0 }}>
            <Box
              sx={{
                bgcolor: "white",
                borderRadius: "20px",
                boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <Box sx={{ flexShrink: 0, px: 3, pt: 3, pb: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 800, color: "#334155" }}>
                  Campaign Settings
                </Typography>
              </Box>

              <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: 3, pb: 3 }}>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, color: "#64748b", mb: 1 }}>
                    Sender Identity
                  </Typography>
                  <TextField
                    fullWidth
                    disabled
                    value={user.username}
                    variant="outlined"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        bgcolor: "#f8fafc",
                      },
                    }}
                  />
                </Box>

                <Box sx={{ mb: 3 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, color: "#64748b", mb: 1 }}>
                    Target Group
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    <Select
                      fullWidth
                      value={group}
                      onChange={handleGroupChange}
                      error={groupError}
                      displayEmpty
                      variant="outlined"
                      sx={{ borderRadius: "12px", bgcolor: "#fff" }}
                    >
                      <MenuItem value="" disabled>
                        Select target group...
                      </MenuItem>
                      {groups?.length > 0 &&
                        groups.map((group, index) => (
                          <MenuItem key={index} value={group._id}>
                            {group.name}
                          </MenuItem>
                        ))}
                    </Select>
                    {/* <Tooltip title="Edit Selected Group">
                    <IconButton
                      onClick={handleEditGroupClick}
                      disabled={!group}
                      sx={{
                        bgcolor: "#fff",
                        border: "1px solid #e2e8f0",
                        "&:hover": { bgcolor: "#f1f5f9" }
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip> */}
                  </Box>
                  {groupError && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block", fontWeight: 600 }}>
                      Recipient group is required
                    </Typography>
                  )}
                </Box>

                <Box sx={{ mb: 4 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, color: "#64748b", mb: 1 }}>
                    Subject Line
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="e.g. Weekly Top Talent Hotlist"
                    variant="outlined"
                    value={subject}
                    onChange={handleSubjectChange}
                    error={subjectError}
                    helperText={subjectError ? "Subject line is necessary" : ""}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        bgcolor: "#fff",
                      },
                    }}
                  />
                </Box>

                <Divider sx={{ mb: 3 }} />

                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 700, color: "#64748b", mb: 1.5 }}>
                    Attachments
                  </Typography>
                  <Box
                    sx={{
                      border: "2px dashed #e2e8f0",
                      borderRadius: "12px",
                      p: 2,
                      textAlign: "center",
                      bgcolor: "#f8fafc",
                    }}
                  >
                    <input
                      type="file"
                      id="mailer-file-upload"
                      hidden
                      accept=".pdf,.doc,.docx,.txt"
                      onChange={(e) => {
                        if (e.target.files && e.target.files[0]) {
                          setAttachment(e.target.files[0]);
                          setAttachmentName(e.target.files[0].name);
                        }
                      }}
                    />
                    <IconButton
                      component="label"
                      htmlFor="mailer-file-upload"
                      sx={{ bgcolor: "#fff", boxShadow: "0 1px 2px rgba(0,0,0,0.05)", mb: 1 }}
                    >
                      <DownloadIcon fontSize="small" color="primary" />
                    </IconButton>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: "#475569" }}>
                      {attachmentName || "Click to attach document"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={7} sx={{ height: { md: "100%" }, display: "flex", minHeight: 0 }}>
            <Box
              sx={{
                bgcolor: "white",
                borderRadius: "20px",
                p: 1,
                boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <Box sx={{ flexShrink: 0, p: 1, borderBottom: "1px solid #f1f5f9" }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 800, color: "#334155" }}>
                  Hotlist Preview
                </Typography>
              </Box>

              <Box sx={{ flex: 1, minHeight: 0, p: 2, overflowY: "auto" }}>
                {activeCandidates?.length > 0 ? (
                  <TableContainer component={Paper} elevation={0} sx={{ borderRadius: "12px", border: "1px solid #f1f5f9", overflowX: 'auto' }}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ bgcolor: "#f8fafc", fontWeight: 800, color: "#64748b" }}>Name</TableCell>
                          <TableCell sx={{ bgcolor: "#f8fafc", fontWeight: 800, color: "#64748b" }}>Stack</TableCell>
                          <TableCell sx={{ bgcolor: "#f8fafc", fontWeight: 800, color: "#64748b" }}>Exp</TableCell>
                          <TableCell sx={{ bgcolor: "#f8fafc", fontWeight: 800, color: "#64748b" }}>Location</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {activeCandidates.map((candidate, rowIndex) => {
                          const resume = primaryResumes[rowIndex] || {};
                          return (
                            <TableRow key={rowIndex} sx={{ "&:hover": { bgcolor: "#fdfdfd" } }}>
                              <TableCell sx={{ fontWeight: 700, color: "#1e293b" }}>
                                {candidate.candidate_name || "N/A"}
                              </TableCell>
                              <TableCell>
                                <Box
                                  sx={{
                                    bgcolor: "#f1f5f9",
                                    px: 1.5,
                                    py: 0.5,
                                    borderRadius: "8px",
                                    display: "inline-block",
                                    fontSize: "0.75rem",
                                    fontWeight: 700,
                                    color: "#475569",
                                  }}
                                >
                                  {candidate.role || "N/A"}
                                </Box>
                              </TableCell>
                              <TableCell sx={{ color: "#64748b", fontWeight: 600 }}>
                                {candidate.work_experience || candidate.total_experience || candidate.experience || "N/A"}
                              </TableCell>
                              <TableCell sx={{ color: "#64748b", fontSize: "0.8rem" }}>
                                {candidate.location || candidate.address || "N/A"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Box
                    sx={{
                      height: "200px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "#f8fafc",
                      borderRadius: "16px",
                      border: "2px dashed #e2e8f0",
                      gap: 2
                    }}
                  >
                    {activeCandLoading ? (
                      <>
                        <CircularProgress size={32} thickness={5} sx={{ color: "#2563eb" }} />
                        <Typography variant="body2" sx={{ color: "#2563eb", fontWeight: 700 }}>
                          Loading candidates...
                        </Typography>
                      </>
                    ) : (
                      <Typography variant="body2" sx={{ color: "#94a3b8", fontWeight: 600 }}>
                        Your candidate list is currently empty.
                      </Typography>
                    )}
                  </Box>
                )}
              </Box>

              <Box
                sx={{
                  flexShrink: 0,
                  p: 2,
                  pt: 1.5,
                  borderTop: "1px solid #f1f5f9",
                }}
              >
                <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#334155", mb: 1.5 }}>
                  Closing Message
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  value={additionalText}
                  onChange={(e) => setAdditionalText(e.target.value)}
                  placeholder="Add a personalized closing note to your campaign..."
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "16px",
                      bgcolor: "#f8fafc",
                      border: "1px solid #f1f5f9",
                    },
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Dialog
        open={editOpen}
        onClose={() => setEditOpen(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: { borderRadius: "16px", overflow: "hidden" }
        }}
      >
        <DialogTitle sx={{ bgcolor: "#f8fafc", p: 2.5, borderBottom: "1px solid #e2e8f0" }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" sx={{ fontWeight: 800, color: "#1e3a8a" }}>
              Edit Group
            </Typography>
            <IconButton onClick={() => setEditOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ mb: 3, mt: 1 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#475569", mb: 1 }}>
              GROUP NAME
            </Typography>
            <TextField
              fullWidth
              value={editName}
              onChange={(e) => setEditName(e.target.value)}
              placeholder="Enter group name"
              variant="outlined"
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
            />
          </Box>

          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#475569", mb: 1 }}>
            MANAGE EMAILS ({editSearchTerm ? `${editEmails.filter(e => e.toLowerCase().includes(editSearchTerm.toLowerCase())).length} of ${editEmails.length}` : editEmails.length})
          </Typography>

          <Box sx={{ mb: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Add new email..."
                value={newEmailEntry}
                onChange={(e) => setNewEmailEntry(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleAddNewEditEmail()}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
              />
              <Button
                variant="contained"
                disableElevation
                onClick={handleAddNewEditEmail}
                sx={{ borderRadius: "10px", textTransform: "none", fontWeight: 700, bgcolor: "#2563eb" }}
              >
                Add
              </Button>
            </Box>

            <Paper
              elevation={0}
              sx={{
                p: '2px 4px',
                display: 'flex',
                alignItems: 'center',
                bgcolor: "#f1f5f9",
                border: "1px solid #e2e8f0",
                borderRadius: "10px",
              }}
            >
              <IconButton sx={{ p: '8px', color: "#94a3b8" }} size="small">
                <SearchIcon fontSize="small" />
              </IconButton>
              <InputBase
                sx={{ ml: 1, flex: 1, fontSize: "0.875rem", fontWeight: 500 }}
                placeholder="Search emails in this group..."
                value={editSearchTerm}
                onChange={(e) => setEditSearchTerm(e.target.value)}
              />
              {editSearchTerm && (
                <IconButton sx={{ p: '8px' }} size="small" onClick={() => setEditSearchTerm("")}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              )}
            </Paper>
          </Box>

          <Paper variant="outlined" sx={{ borderRadius: "12px", maxHeight: "300px", overflow: "auto" }}>
            <List sx={{ p: 0 }}>
              {editEmails
                .filter(email => email.toLowerCase().includes(editSearchTerm.toLowerCase()))
                .map((email, index) => {
                  // Important: use the actual index in editEmails for updates/removals
                  const actualIndex = editEmails.findIndex(e => e === email);
                  return (
                    <ListItem
                      key={index}
                      divider={index < editEmails.length - 1}
                      sx={{ px: 2, py: 1 }}
                    >
                      {emailEditingIndex === actualIndex ? (
                        <TextField
                          fullWidth
                          autoFocus
                          size="small"
                          value={emailEditingValue}
                          onChange={(e) => setEmailEditingValue(e.target.value)}
                          onBlur={() => handleUpdateEditEmail(actualIndex, emailEditingValue)}
                          onKeyPress={(e) => e.key === 'Enter' && handleUpdateEditEmail(actualIndex, emailEditingValue)}
                        />
                      ) : (
                        <>
                          <ListItemAvatar sx={{ minWidth: 45 }}>
                            <Avatar sx={{ width: 32, height: 32, bgcolor: stringToColor(email), fontSize: "0.8rem" }}>
                              {email.charAt(0).toUpperCase()}
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={<Typography variant="body2" sx={{ fontWeight: 600 }}>{email}</Typography>}
                          />
                          <Stack direction="row" spacing={0.5}>
                            <IconButton
                              size="small"
                              onClick={() => {
                                setEmailEditingIndex(actualIndex);
                                setEmailEditingValue(email);
                              }}
                              sx={{ color: "#64748b", "&:hover": { color: "#2563eb" } }}
                            >
                              <EditIcon sx={{ fontSize: "18px" }} />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => handleRemoveEditEmail(actualIndex)}
                              sx={{ color: "#94a3b8", "&:hover": { color: "#ef4444" } }}
                            >
                              <DeleteIcon sx={{ fontSize: "18px" }} />
                            </IconButton>
                          </Stack>
                        </>
                      )}
                    </ListItem>
                  );
                })}
              {editEmails.filter(email => email.toLowerCase().includes(editSearchTerm.toLowerCase())).length === 0 && (
                <Box sx={{ p: 3, textAlign: 'center', color: "#94a3b8" }}>
                  {editSearchTerm ? "No matching emails found" : "No emails in this group"}
                </Box>
              )}
            </List>
          </Paper>
        </DialogContent>
        <DialogActions sx={{ p: 2.5, bgcolor: "#f8fafc", borderTop: "1px solid #e2e8f0" }}>
          <Button onClick={() => setEditOpen(false)} sx={{ fontWeight: 700, textTransform: "none", color: "#64748b" }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disableElevation
            onClick={handleUpdateSubmit}
            disabled={isSubmitting || editName.trim() === ""}
            sx={{
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 700,
              px: 4,
              bgcolor: "#1e3a8a",
              "&:hover": { bgcolor: "#1e293b" }
            }}
          >
            {isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save Changes"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Mailer;
